import React from 'react'
import "./CallToAction.css"
import { useNavigate } from 'react-router-dom'
function CallToAction() {
    const navigate = useNavigate()
  return (
    <div className='CallToAction-container standard-padding-space'>
        <div className='container d-flex flex-column align-items-center mt-3 mb-4'>
            {/* <img src='/images/icons/ourvalues-icon.svg' alt='value icon' className='img-fluid mb-4' />  */}
            <h3 className='body-heading text-center mb-3'>Ready to bring this course to your team?</h3>
            <p className='body-paragraph text-center'>Whether you're a brokerage, an association, or an individual agent — reach out to discuss scheduling and group pricing.</p>
            <div className='d-flex flex-lg-row flex-column gap-lg-3 gap-1 pt-2 pb-3'>
                {/* <button className='genral-btn-light'>Join the Waitlist </button> */}
                <button className='genral-btn-light ' onClick={()=>{window.open("tel:(437) 998-6650")}}>Get in touch </button>
            </div>
            <p className='body-paragraph text-center mb-0'>Louay Nouneh &nbsp; · &nbsp; <span onClick={()=>{window.open('tel:(437) 998-6650')}} className='cursor-pointer'>(437) 998-6650</span> &nbsp; · &nbsp; <span onClick={()=>{window.open('mailto:louay@mesdecors.ca')}} className='cursor-pointer'>louay@mesdecors.ca</span> &nbsp; · &nbsp; mesdecors.ca</p>
        </div>
    </div>
  )
}

export default CallToAction